import { z } from "zod";

export const validationSchema = z.object({
  color: z.string().nonempty(),
  name: z.string().nonempty(),
  teamId: z.string().uuid(),
});
